/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  SimpleContractApprovalStatus
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetSimpleContractApprovalStatusesUrl = () => {




  return `/api/ContractApprovalStatus/GetSimpleContractApprovalStatuses`
}

export const getSimpleContractApprovalStatuses = async ( options?: Parameters<typeof customInstance>[1]): Promise<SimpleContractApprovalStatus[]> => {

  return customInstance<SimpleContractApprovalStatus[]>(getGetSimpleContractApprovalStatusesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSimpleContractApprovalStatusesQueryKey = () => {
    return [
    `/api/ContractApprovalStatus/GetSimpleContractApprovalStatuses`
    ] as const;
    }


export const getGetSimpleContractApprovalStatusesQueryOptions = <TData = Awaited<ReturnType<typeof getSimpleContractApprovalStatuses>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleContractApprovalStatuses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimpleContractApprovalStatusesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimpleContractApprovalStatuses>>> = ({ signal }) => getSimpleContractApprovalStatuses({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSimpleContractApprovalStatuses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSimpleContractApprovalStatusesQueryResult = NonNullable<Awaited<ReturnType<typeof getSimpleContractApprovalStatuses>>>
export type GetSimpleContractApprovalStatusesQueryError = ErrorType<unknown>


export function useGetSimpleContractApprovalStatuses<TData = Awaited<ReturnType<typeof getSimpleContractApprovalStatuses>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleContractApprovalStatuses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimpleContractApprovalStatuses>>,
          TError,
          Awaited<ReturnType<typeof getSimpleContractApprovalStatuses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleContractApprovalStatuses<TData = Awaited<ReturnType<typeof getSimpleContractApprovalStatuses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleContractApprovalStatuses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimpleContractApprovalStatuses>>,
          TError,
          Awaited<ReturnType<typeof getSimpleContractApprovalStatuses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleContractApprovalStatuses<TData = Awaited<ReturnType<typeof getSimpleContractApprovalStatuses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleContractApprovalStatuses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSimpleContractApprovalStatuses<TData = Awaited<ReturnType<typeof getSimpleContractApprovalStatuses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleContractApprovalStatuses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSimpleContractApprovalStatusesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSimpleContractApprovalStatusesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSimpleContractApprovalStatuses>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleContractApprovalStatuses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimpleContractApprovalStatusesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimpleContractApprovalStatuses>>> = ({ signal }) => getSimpleContractApprovalStatuses({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleContractApprovalStatuses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetSimpleContractApprovalStatusesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSimpleContractApprovalStatuses>>>
export type GetSimpleContractApprovalStatusesSuspenseQueryError = ErrorType<unknown>


export function useGetSimpleContractApprovalStatusesSuspense<TData = Awaited<ReturnType<typeof getSimpleContractApprovalStatuses>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleContractApprovalStatuses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleContractApprovalStatusesSuspense<TData = Awaited<ReturnType<typeof getSimpleContractApprovalStatuses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleContractApprovalStatuses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleContractApprovalStatusesSuspense<TData = Awaited<ReturnType<typeof getSimpleContractApprovalStatuses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleContractApprovalStatuses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSimpleContractApprovalStatusesSuspense<TData = Awaited<ReturnType<typeof getSimpleContractApprovalStatuses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleContractApprovalStatuses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSimpleContractApprovalStatusesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






